import React from 'react';
import { Header, Footer } from '../../component/index';

const Question = () => {
    return (
        <>
        <Header homepage={false}/>
        <div className="wrapper">
            <div className="container-w-lg">
                <div className="row">
                    <img src="static/images/img_banner_FAQ.png" alt="features" width="100%"/>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="page-title-box">
                            <h4 className="page-title">FAQ</h4>
                        </div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="row">
                        <div className="title_underline"></div>
                    </div>
                </div>
                <div className="row justify-content-center m-b-50">
                <div className="accordion col-sm-10 m-t-50 m-b-50" id="accordionExample">
                    <div className="card m-b-15">
                        <div className="card-header" id="heading1">
                            <h2 className="text-white m-0">
                                <a className="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                                    Q. How many clients does WorldCard Team support?
                                    <i className="mdi mdi-chevron-down"></i>
                                </a>
                            </h2>
                        </div>
                        <div id="collapse1" className="collapse" aria-labelledby="heading1" data-parent="#accordionExample">
                            <div className="card-body">
                                A. To ensure the best performance from WorldCard Team, the recommended amount of users of NAS edition is under ten. If more people in the company need to use WorldCard Team service, please choose the Windows Server edition, the maximum number of users will vary depending on your server performance.
                            </div>
                        </div>
                    </div>
                    <div className="card m-b-15">
                        <div className="card-header" id="heading2">
                            <h2 className="text-white m-0">
                                <a className="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapseOne">
                                    Q. Our colleagues have used WorldCard for a long time. How can we process the existing contact data?
                                    <i className="mdi mdi-chevron-down"></i>
                                </a>
                            </h2>
                        </div>
                        <div id="collapse2" className="collapse" aria-labelledby="heading2" data-parent="#accordionExample">
                            <div className="card-body">
                                A. You can import the contact data to WorldCard Team from WorldCard or WorldCard Mobile. When you set up the WorldCard Team system for your company, we suggest that you can transfer all contacts to WorldCard Team instead of continuing to use WorldCard.
                            </div>
                        </div>
                    </div>
                    <div className="card m-b-15">
                        <div className="card-header" id="heading3">
                            <h2 className="text-white m-0">
                                <a className="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapseOne">
                                    Q. Can I use the WorldCard Team system when going on a business trip?
                                    <i className="mdi mdi-chevron-down"></i>
                                </a>
                            </h2>
                        </div>
                        <div id="collapse3" className="collapse" aria-labelledby="heading3" data-parent="#accordionExample">
                            <div className="card-body">
                                A. Yes! You can access WorldCard Team even when you are away from the office. With the help of Fixed IP settings or DDNS service (for Dynamic IP), users can connect with WorldCard Team Server and access contacts anytime anywhere. Please refer to the user manual for further details.
                            </div>
                        </div>
                    </div>
                    <div className="card m-b-15">
                        <div className="card-header" id="heading4">
                            <h2 className="text-white m-0">
                                <a className="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapseOne">
                                    Q. How many contacts can WorldCard Team store?
                                    <i className="mdi mdi-chevron-down"></i>
                                </a>
                            </h2>
                        </div>
                        <div id="collapse4" className="collapse" aria-labelledby="heading4" data-parent="#accordionExample">
                            <div className="card-body">
                                A. Every client can save 25,000 contacts in their account. The WorldCard Team server can store 360,000 contacts for the whole company.
                            </div>
                        </div>
                    </div>
                    <div className="card m-b-15">
                        <div className="card-header" id="heading5">
                            <h2 className="text-white m-0">
                                <a className="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapse5" aria-expanded="false" aria-controls="collapseOne">
                                    Q. May I have my assistant scanning business cards and adding contacts for me?
                                    <i className="mdi mdi-chevron-down"></i>
                                </a>
                            </h2>
                        </div>
                        <div id="collapse5" className="collapse" aria-labelledby="heading5" data-parent="#accordionExample">
                            <div className="card-body">
                                A. Sure. You can assign the scanning work to your assistant. The contact data will be transferred to your account without leaving a copy in assistant’s account after the scanning work.
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="above-footer"></div>
        </div>
        <Footer/>
        </>
    )
}

export default Question;